<div
    class="chat-session-item"
    [class.chat-session-item--active]="active"
    [class.chat-session-item--with-avatar]="showAvatar && type !== 'agent'"
    role="button"
    tabindex="0"
    (click)="selected.emit()"
    (keydown.enter)="selected.emit()"
    (keydown.space)="selected.emit(); $event.preventDefault()"
>
    <!-- Аватар (User Chat / Context Chat) -->
    <div class="chat-session-item__avatar" *ngIf="showAvatar && type !== 'agent'">
        <img
            *ngIf="session.avatarUrl; else initialsBlock"
            [src]="session.avatarUrl"
            [alt]="session.title"
            class="chat-session-item__avatar-img"
        />
        <ng-template #initialsBlock>
            <span class="chat-session-item__avatar-initials">{{ initials }}</span>
        </ng-template>
        <span class="chat-session-item__avatar-online" *ngIf="showOnlineIndicator && session.isOnline"></span>
    </div>

    <!-- Контент -->
    <div class="chat-session-item__body">

        <!-- Строка заголовка -->
        <div class="chat-session-item__header">
            <div class="chat-session-item__title-group">
                <span class="chat-session-item__title">{{ session.title }}</span>
                <!-- Время рядом с именем — если есть caption-контент ниже (User / Context) -->
                <span class="chat-session-item__time" *ngIf="session.updatedAtLabel && (hasSubtitles || captionText) && type !== 'agent'">
                    {{ session.updatedAtLabel }}
                </span>
            </div>

            <!-- Кнопка удаления — появляется при hover, если разрешено -->
            <span *ngIf="menuItems.length" class="chat-session-item__menu" (click)="$event.stopPropagation()">
                <button
                    ui-kit
                    buttonFunction
                    dropdown
                    [dropdownList]="resolvedMenuItems"
                    iconName="menu"
                    color="neutral"
                    size="extra-small"
                    type="button"
                ></button>
            </span>
        </div>

        <!-- Subtitles — только для Context Chat -->
        <div class="chat-session-item__subtitles" *ngIf="type === 'context' && hasSubtitles">
            <div class="chat-session-item__subtitle" *ngFor="let sub of session.subtitles">
                <span class="chat-session-item__subtitle-label">{{ sub.label }}</span>
                <span class="chat-session-item__subtitle-text">{{ sub.text }}</span>
            </div>
        </div>

        <!-- Caption-строка -->
        <div class="chat-session-item__caption" *ngIf="captionText || showUnreadBadge || (type === 'agent' && session.updatedAtLabel)">
            <span class="chat-session-item__caption-text" *ngIf="type === 'agent' && session.updatedAtLabel">
                {{ session.updatedAtLabel }}
            </span>
            <span class="chat-session-item__caption-text" *ngIf="type !== 'agent' && captionText">
                {{ captionText }}
            </span>

            <div class="chat-session-item__caption-icons">
                <count ui-kit
                    *ngIf="showUnreadBadge"
                    severity="shape-text"
                    size="small"
                    [value]="session.unreadCount"
                ></count>
            </div>
        </div>

    </div>
</div>
